/**
 * Shared color utility functions
 */

/**
 * Converts hex color to RGB values
 */
export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  // Handle both #RGB and #RRGGBB formats
  const cleanHex = hex.replace('#', '')
  
  if (cleanHex.length === 3) {
    // Short format: #RGB -> #RRGGBB
    const r = parseInt(cleanHex[0] + cleanHex[0], 16)
    const g = parseInt(cleanHex[1] + cleanHex[1], 16)
    const b = parseInt(cleanHex[2] + cleanHex[2], 16)
    return { r, g, b }
  } else if (cleanHex.length === 6) {
    const r = parseInt(cleanHex.substring(0, 2), 16)
    const g = parseInt(cleanHex.substring(2, 4), 16)
    const b = parseInt(cleanHex.substring(4, 6), 16)
    return { r, g, b }
  }
  
  return null
}

/**
 * Converts RGB to hex
 */
export function rgbToHex(r: number, g: number, b: number): string {
  const toHex = (n: number) => {
    const hex = Math.round(Math.max(0, Math.min(255, n))).toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }
  
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

/**
 * Parses color string (hex or rgb/rgba) and returns RGB values
 */
export function parseColor(color: string): { r: number; g: number; b: number } | null {
  const trimmed = color.trim()
  
  // Handle RGB/RGBA format
  if (trimmed.startsWith('rgb')) {
    const rgbMatch = trimmed.match(/\d+/g)
    if (rgbMatch && rgbMatch.length >= 3) {
      return {
        r: parseInt(rgbMatch[0]),
        g: parseInt(rgbMatch[1]),
        b: parseInt(rgbMatch[2]),
      }
    }
  }
  
  // Handle hex format
  if (trimmed.startsWith('#')) {
    return hexToRgb(trimmed)
  }
  
  // Try parsing without # prefix
  return hexToRgb('#' + trimmed)
}
